import { ReactNode } from 'react';
import { Typography } from '../../../../Typography';
import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';

interface TagProps {
  variant: 'primary' | 'secondary';
  title: string;
  rightContent?: ReactNode;
  sectionClassName?: string;
  containerClassName?: string;
  typographyClassName?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const Tag = ({
  variant,
  title,
  rightContent,
  sectionClassName,
  containerClassName,
  typographyClassName,
  size = 'md',
}: TagProps) => {
  const sizes = {
    sm: 'p-2',
    md: 'px-6 py-2.5',
    lg: 'px-8 py-3',
  };

  const variantStyles =
    variant === 'primary'
      ? {
          typography: '!text-text-primary !font-700',
          container: '!bg-bg-secondary',
        }
      : {
          container: '!bg-primary-400',
          typography: '!text-text-secondary',
        };

  return (
    <section
      className={flattenClassNames([
        'row-start-1 row-end-2 flex justify-between',
        sectionClassName,
      ])}
    >
      <div
        className={flattenClassNames([
          'relative bottom-6 inline-block rounded-br-md rounded-bl-md shadow-basic',
          sizes[size],
          containerClassName,
          variantStyles.container,
        ])}
      >
        {/* important is being applied here because we have not fixed the color prop  */}
        {/* emotion has higher specificity because it is added to the end of the className */}
        <Typography
          variant="h4"
          className={flattenClassNames([
            'text-h5 uppercase',
            variantStyles.typography,
            typographyClassName,
          ])}
        >
          {title}
        </Typography>
      </div>
      <div className="relative -top-2">{rightContent}</div>
    </section>
  );
};
